var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMailBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1794_6297",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1794_6297)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33268 16.6666C2.87435 16.6666 2.48199 16.5034 2.1556 16.177C1.82921 15.8506 1.66602 15.4583 1.66602 14.9999V4.99992C1.66602 4.54159 1.82921 4.14922 2.1556 3.82284C2.48199 3.49645 2.87435 3.33325 3.33268 3.33325H16.666C17.1243 3.33325 17.5167 3.49645 17.8431 3.82284C18.1695 4.14922 18.3327 4.54159 18.3327 4.99992V14.9999C18.3327 15.4583 18.1695 15.8506 17.8431 16.177C17.5167 16.5034 17.1243 16.6666 16.666 16.6666H3.33268ZM9.99935 10.8333L3.33268 6.66659V14.9999H16.666V6.66659L9.99935 10.8333ZM9.99935 9.16659L16.666 4.99992H3.33268L9.99935 9.16659ZM3.33268 6.66659V4.99992V14.9999V6.66659Z",
    fill: "#00BCE7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMailBlue);
export default __webpack_public_path__ + "static/media/ic-mail-blue.4e4ecfd1a70d035a53614f2f0df34d30.svg";
export { ForwardRef as ReactComponent };